import React from "react";
import VacancesOFPPT2026 from "./Components/vacances"; // Assurez-vous que le chemin est correct

function App() {
  return (
    <div>
      <VacancesOFPPT2026/>
    </div>
  );
}

export default App;
